// src/hooks/usePageContent.js
import { useState } from "react";
import { getProductVariant } from "../services/productService";

const useProductVariant = () => {
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [error, setError] = useState("");
  const [data, setData] = useState([]);

  const fetchVariant = async (productId) => {
    setStatus("loading");
    setError("");

    try {
      const response = await getProductVariant(productId);

      if (response?.status !== "Error") {
        setData(response.data ?? response); // depending on API shape
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

  const resetStatus = () => {
    setStatus("idle");
    setError("");
  };

  return {
    fetchVariant,
    data,
    status,
    error,
    resetStatus,
  };
};

export default useProductVariant;
